<template>
	<div class="marketing-properties-item">
		<p class="heading">
			{{ question }}
		</p>
		<div class="wrapper">
			<r-standard-selectfield
				slot="input"
				ref="field"
				placeholder="Please select"
				:defaultToFirstOption="false"
				:field="state"
				:choiceArray="rawData.choices"
				@updated="updated"
			/>
		</div>
	</div>
</template>
<script>

export default {
    data() {
		let rawData = {};
		if (this.component.type === "select") {
			rawData = {
				choices: []
			}
			let options = Object.keys(this.component.options);
			for (let j = 0; j < options.length; j++) {
				rawData.choices.push({
					label: options[j],
					value: options[j]
				});
			}
		}
        return {
			state: {},
			rawData
		}
    },
	props: {
		question: {
			required: true
		},
		component: {
			required: true,
		}
	},
    methods: {
        updated(value) {
			if (value) {
				this.$emit("updated", value, this.component.options[value]);
			}
        }
    }
};
</script>
<style scoped lang="scss">
.marketing-properties-item {
	.heading {
		color: $p-color-grey-400;
		margin: 0px;
		padding-bottom: 2px;
	}
	.wrapper {

	}
	margin-bottom: 4px;
}
</style>